import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"

import ShopNowGrid from "components/shop-now-grid"
import Button from "components/ui/button"

const GenericNotFound = ({ staticContext = {} }) => {
  staticContext.status = 404

  return (
    <>
      <Helmet>
        <meta content="noindex" name="robots" />
      </Helmet>
      <div className="mt-32 px-16 text-center">
        <h1 className="h1 tablet:mb-16">Page Not Found</h1>
        <p className="body-lg">
          We&apos;re sorry, the page that you are looking for cannot be found.
        </p>
        <Button
          asChild
          className="tablet:inline-flex mt-16 hidden font-semibold"
          variant="primary"
        >
          <Link data-lc="not-found" to="/">
            Continue Shopping
          </Link>
        </Button>
      </div>
      <ShopNowGrid />
      <div className="tablet:hidden px-16 pb-32">
        <Button asChild className="w-full font-semibold" variant="primary">
          <Link data-lc="not-found" to="/">
            Continue Shopping
          </Link>
        </Button>
      </div>
    </>
  )
}

GenericNotFound.propTypes = {
  staticContext: PropTypes.object,
}

export default GenericNotFound
